// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './polyfill'
import '@fortawesome/fontawesome-free/css/all.css'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import store from './store/store'
import router from './router/index'
import Vuelidate from "vuelidate"
import i18n from './locale/index'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import VueQuillEditor from "vue-quill-editor"

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Toast)
Vue.use(VueQuillEditor)

Vue.mixin({
  methods: {
    checkPermission(permissionId) {
      if(!permissionId){
        return true
      }
      return this.$store.getters['user/getPermission'](permissionId)
    }
  }
})
export const app = new Vue({
  el: '#app',
  i18n,
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})
